<template>
    <breadCrumbs title="Kanban Board" title1="Kanban Board" />
    <div class="container-fluid jkanban-container">
        <div class="row">
            <defaultDemo />
            <customBoard />
            <api />
            <div class="col-12">
                <div class="card kanban-note p-20">jKanban is Pure agnostic Javascript plugin for Kanban boards for more
                    options please refer <a href="http://www.riccardotartaglia.it/jkanban/" target="_blank">jkanban Official
                        site </a>And <a href="https://github.com/riktar/jkanban" target="_blank">githup link</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import api from './api.vue'
import defaultDemo from "./defaultDemo.vue"
import customBoard from "./customBoard.vue"

export default {
    name: "App",
    components: {
        api, defaultDemo, customBoard
    },
};
</script>